import { getSanitizedTicker } from '../../../app/shared/ticker-sanitizer'
import { link } from '../../services/routing'
import { Instrument } from '../../types'
import { getInstrumentForTicker } from '../../util'

export function getRedirectForTicker(tickerRaw: string) {
  const ticker = getSanitizedTicker(tickerRaw, true)
  const type = getInstrumentForTicker(ticker)

  switch (Instrument[type]) {
    case Instrument.stock:
      return link.toQuote(ticker)
    case Instrument.forex:
      return link.toForexChartDetail(ticker)
    case Instrument.futures:
      return link.toFuturesChartDetail(ticker)
    case Instrument.crypto:
      return link.toCryptoChartDetail(ticker)
    default:
      // Not used right now, all instruments are `stock` by default
      return link.toSearch(ticker)
  }
}
